import { reducerWithInitialState } from "typescript-fsa-reducers";
import { updateDebugStatus } from "./actions";

const debugReducer = reducerWithInitialState<Readonly<boolean>>(false).case(
  updateDebugStatus,
  (state, isDebug) => isDebug
);

export default debugReducer;



// WEBPACK FOOTER //
// ./src/spread/model/debug/reducer.ts